module.exports = __webpack_public_path__ + "assets/img/media-music-layer-2-e5e39e24.png";